import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/clients/ff5a48c1f030f673fbc44b0fd81e7291/web/dev.intento.ch/src/components/ecommerce/category-page-view.tsx");
